var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import classNames from 'classnames';
import { InfoFilled, WarnFilled, ErrorFilled, SuccessFilled, InfoOutlined, WarnOutlined, ErrorOutlined, SuccessOutlined, CloseOutlined, } from '@feb-team/legao-icons-react';
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function () {
            var _a = _this.props, onClose = _a.onClose, onBeforeClose = _a.onBeforeClose;
            _this.setState({ showAlert: false }, function () {
                if (onBeforeClose()) {
                    onClose();
                }
            });
        };
        _this.renderClose = function () {
            var close = _this.props.close;
            if (close === false) {
                return null;
            }
            else if (typeof close === 'boolean' && close === true) {
                var svgCls = [
                    'absolute',
                    'top-0',
                    'right-0',
                    'mr-4',
                    'mt-px-10',
                    'w-4',
                    'h-4',
                    'fill-gray-600',
                    'cursor-pointer',
                ];
                return React.createElement(CloseOutlined, { className: svgCls.join(' '), onClick: _this.close });
            }
            else {
                return (React.createElement(SpanTag, { atomics: "cursor-pointer", onClick: _this.close }, close));
            }
        };
        _this.state = {
            showAlert: true,
        };
        return _this;
    }
    Alert.prototype.render = function () {
        var _a;
        var _b = this.props, type = _b.type, content = _b.content, description = _b.description, showIcon = _b.showIcon, icon = _b.icon, close = _b.close, onBeforeClose = _b.onBeforeClose, onClose = _b.onClose, hasBorder = _b.hasBorder, rest = __rest(_b, ["type", "content", "description", "showIcon", "icon", "close", "onBeforeClose", "onClose", "hasBorder"]);
        var showAlert = this.state.showAlert;
        if (!showAlert) {
            return null;
        }
        var boxCls = [
            'relative',
            'flex',
            'items-start',
            'rounded',
            'border',
            'text-sm',
        ];
        var setBoxClsString = classNames((_a = {},
            _a['py-4 px-px-24'] = description,
            _a['h-px-40 px-px-16 items-center'] = !description,
            _a['no-border'] = !hasBorder,
            _a));
        var setBoxCls = setBoxClsString.split(/\s/g);
        var contCls = ['overflow-hidden'];
        var msgCls = description
            ? ['leading-snug', 'text-base']
            : ['leading-snug', 'text-sm'];
        var descCls = ['pt-2', 'text-gray-600'];
        var setClsObj = {
            info: {
                box: ['border-brand-600', 'bg-brand-10'],
                icon: 'text-brand-600',
                filled: InfoFilled,
                outlined: InfoOutlined,
            },
            default: {
                box: ['border-brand-600', 'bg-brand-10'],
                icon: 'text-brand-600',
                filled: InfoFilled,
                outlined: InfoOutlined,
            },
            warning: {
                box: ['border-warn-900', 'bg-warn-800'],
                icon: 'text-warn-900',
                filled: WarnFilled,
                outlined: WarnOutlined,
            },
            error: {
                box: ['border-error-900', 'bg-warn-800'],
                icon: 'text-error-900',
                filled: ErrorFilled,
                outlined: ErrorOutlined,
            },
            success: {
                box: ['border-succ-900', 'bg-succ-800'],
                icon: 'text-succ-900',
                filled: SuccessFilled,
                outlined: SuccessOutlined,
            },
        };
        var icoCls = description
            ? ['mr-4', 'w-6', 'h-6', 'text-2xl']
            : ['mr-2', 'w-4', 'h-4', 'text-base'];
        var setIcoCls = __spread([setClsObj[type].icon], icoCls);
        var suffix = description ? 'outlined' : 'filled';
        var typeIcon = setClsObj[type][suffix];
        var defaultIcon = null;
        if (typeIcon) {
            defaultIcon = React.createElement(typeIcon);
        }
        var closeDom = this.renderClose();
        return (React.createElement(DivTag, __assign({ name: Alert.NAME, atomics: __spread(boxCls, setClsObj[type].box, setBoxCls) }, rest),
            showIcon && (icon ? icon : React.createElement(SpanTag, { atomics: setIcoCls }, defaultIcon)),
            React.createElement(DivTag, { atomics: contCls },
                content && React.createElement(DivTag, { atomics: msgCls }, content),
                description && React.createElement(DivTag, { atomics: descCls }, description)),
            closeDom));
    };
    Alert.defaultProps = defaultProps;
    Alert.NAME = 'alert';
    Alert.displayName = 'Alert';
    return Alert;
}(PureComponent));
export { Alert };
